const activityLogTypes = [
  { id: 15, name: 'ConfirmMissingOptionalResources', description: 'Confirmed Missing Optional Resources' },
]

export default activityLogTypes
